export default __webpack_public_path__ + "static/media/15.34b1c174.jpg";